import { initializeDataSources } from '@/databases/utils'

export default defineNuxtPlugin( async (nuxtApp) => {
  if (import.meta.client) {
    const dataSource = await initializeDataSources()
    nuxtApp.provide('dataSource', dataSource)
  }
})